const QuestionTypes = Object.freeze({
    MULTICHOICE: "multichoice",
    TRUE_FALSE: "true_false",
    DROPDOWN: "dropdown",
    FILE_UPLOAD: "file_upload",
    YES_NO: "yes_no",
    SHORT_ANSWER: "short_answer",
    INFORMATION: "information"
});

export default QuestionTypes;